/**
 * Adds a leading slash to a slug parameter
 * @param slugParam - The slug parameter (string, array of strings, or undefined)
 * @returns A string with a leading slash
 */
export const ensureLeadingSlash = (slugParam: string | string[] | undefined): string => {
  if (!slugParam || slugParam === '' || slugParam === '/') {
    return '/'
  }

  if (Array.isArray(slugParam)) {
    const joined = slugParam.join('/')
    if (!joined || joined === '') {
      return '/'
    }
    return joined.startsWith('/') ? joined : `/${joined}`
  }

  return slugParam.startsWith('/') ? slugParam : `/${slugParam}`
}

/**
 * Removes the leading slash from a slug string
 * @param slug - The slug string with a leading slash
 * @returns A string without the leading slash, or empty string if input is '/'
 */
export const getPageIdFromSlug = (slug: string): string => {
  let trimmedSlug

  if (slug === '/') {
    trimmedSlug = 'homepage'
  } else {
    trimmedSlug = slug.startsWith('/') ? slug.slice(1) : slug
  }

  return `${trimmedSlug}-custom-page`
}
